<template> 
	<div>
		<HeaderPostLogin v-if="loggedIn"></HeaderPostLogin>	    
		<HeaderContent v-else></HeaderContent>
		<TabMenu v-if="loggedIn" :active="1"></TabMenu>
		<!-- Main content Start -->
		<HomeContent :isMobile="false"></HomeContent>
		<!-- Main content End -->
		<FooterContent></FooterContent>
	</div>
</template>

<script>
// @ is an alias to /src
import HeaderContent from '@/views/HeaderContent.vue'
import HeaderPostLogin from '@/views/HeaderPostLogin.vue'
import FooterContent from '@/views/FooterContent.vue'
import TabMenu from '@/components/TabMenu.vue'
import HomeContent from '@/components/HomeContent.vue'

export default {
	components: {
		HeaderContent,
		HeaderPostLogin,
		FooterContent,
		TabMenu,
		HomeContent,
	},
	data() {
		return {
		}
	},
	computed: {
		loggedIn: function() {
			return this.$store.state.loggedIn;
		},
	},
	mounted() {
		document.title = 'Home'
		this.$store.commit('setBackTo', 'Home');
	},
	methods: {
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>